import { errorCode } from '../services/api'

/**
 * The public account-deletion page's rules (`/delete-account`, tooti#150).
 * Google Play asks for a web path that works without the app, so the page
 * runs on a phone number and a one-time code, not on a session.
 */

/** What the backend accepts: E.164 with the leading `+` (auth.dto.ts). */
const E164 = /^\+[1-9][0-9]{7,14}$/

export function isE164(phone) {
  return E164.test(String(phone ?? ''))
}

/** The `deleteAccount:errors.*` key for a failed call — codes the backend documents, anything else generic. */
export function deletionErrorKey(error) {
  switch (errorCode(error)) {
    case 'otp_invalid':
      return 'errors.codeInvalid'
    case 'otp_throttled':
      return 'errors.throttled'
    case 'account_is_admin':
      return 'errors.admin'
    case 'invalid_request':
      return 'errors.phoneInvalid'
    default:
      return 'errors.generic'
  }
}
